export default class Project {
    id: number;
    uuid: string;
    name: string;
    alias: string;
    tariff: any;
}
